import axios, { AxiosError } from 'axios';
import { getStageStatusByCurrentUser, ICandidateStageStatusPipelineSetting } from 'wisestep-api';
import { WsSelectObj } from 'wisestep-base';

export const getStageStatusSettings = async () => {
  try {
    const response = await getStageStatusByCurrentUser();
    return response;
  } catch (e) {
    const error = e as Error | AxiosError;
    if (!axios.isAxiosError(error)) {
      console.log(error);
    }
    console.log(error);
  }
};

export const getCandidateStageCategories = (response: ICandidateStageStatusPipelineSetting) => {
  const candidateStages: string[] = [];

  const stageAndStatuses =
    response?.stageStatusPipeline && JSON.parse(response?.stageStatusPipeline);

  stageAndStatuses?.map((stageAndStatus) => candidateStages.push(`${stageAndStatus.stage}`));

  return candidateStages ?? [];
};

export const getCandidateStagesInWsSelectObj = (response: ICandidateStageStatusPipelineSetting) => {
  const candidateStages: WsSelectObj[] = [];

  const stageAndStatuses =
    response?.stageStatusPipeline && JSON.parse(response?.stageStatusPipeline);

  stageAndStatuses
    ?.filter((stageAndStatus) => !stageAndStatus.isArchive)
    ?.map((stageAndStatus) =>
      candidateStages.push({ label: stageAndStatus.stage, value: stageAndStatus.stage })
    );

  return candidateStages ?? [];
};

export const getCandidateStageData = (response: ICandidateStageStatusPipelineSetting) => {
  const stageAndStatuses =
    response?.stageStatusPipeline && JSON.parse(response?.stageStatusPipeline);

  return stageAndStatuses;
};

export const getAllCandidateStagesInWsSelectObj = (
  response: ICandidateStageStatusPipelineSetting
) => {
  const candidateStages: WsSelectObj[] = [];

  const stageAndStatuses =
    response?.stageStatusPipeline && JSON.parse(response?.stageStatusPipeline);

  stageAndStatuses?.map((stageAndStatus) =>
    candidateStages.push({ label: stageAndStatus.stage, value: stageAndStatus.stage })
  );

  return candidateStages ?? [];
};
